var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0052FF;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286,407.5h-47.2c-0.9-6.1-2.6-11.5-5.3-16.3c-2.7-4.8-6.1-8.9-10.2-12.2c-4.2-3.4-9-6-14.4-7.8 c-5.4-1.8-11.3-2.7-17.6-2.7c-11.4,0-21.4,2.8-29.8,8.5c-8.5,5.6-15,13.8-19.7,24.6c-4.7,10.7-7,23.8-7,39.1 c0,15.7,2.4,29,7.1,39.7c4.7,10.7,11.3,18.8,19.8,24.2c8.5,5.5,18.3,8.2,29.4,8.2c6.2,0,12-0.8,17.4-2.5c5.4-1.7,10.1-4.1,14.3-7.3 c4.2-3.2,7.6-7.1,10.4-11.7c2.8-4.6,4.7-9.8,5.8-15.7l47.2,0.2c-1.2,10.1-4.3,19.9-9.1,29.3c-4.8,9.4-11.4,17.7-19.5,25.1 c-8.2,7.4-17.9,13.2-29.1,17.5c-11.2,4.3-23.9,6.4-38.1,6.4c-19.7,0-37.3-4.5-52.7-13.4c-15.5-8.9-27.7-21.8-36.6-38.7 c-8.9-16.9-13.4-37.3-13.4-61.3c0-24.1,4.5-44.5,13.6-61.4c9.1-16.9,21.3-29.8,36.9-38.6s33-13.3,52.4-13.3 c12.8,0,24.7,1.8,35.6,5.4c11,3.6,20.7,8.8,29.1,15.7c8.5,6.9,15.4,15.2,20.7,25.2C281.1,383.4,284.5,394.7,286,407.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M511.4,440.6c0,24.1-4.5,44.5-13.6,61.4c-9.1,16.9-21.4,29.8-37.1,38.6c-15.6,8.9-33.2,13.3-52.6,13.3 c-19.6,0-37.2-4.5-52.8-13.4c-15.6-8.9-27.9-21.8-37-38.7c-9.1-16.9-13.6-37.3-13.6-61.3c0-24.1,4.5-44.5,13.6-61.4 c9.1-16.9,21.4-29.8,37-38.6c15.6-8.9,33.2-13.3,52.8-13.3c19.5,0,37,4.4,52.6,13.3c15.6,8.9,28,21.7,37.1,38.6 C506.8,396.1,511.4,416.5,511.4,440.6z M464.1,440.6c0-15.6-2.3-28.7-7-39.4c-4.6-10.7-11.2-18.8-19.6-24.4 c-8.4-5.5-18.2-8.3-29.5-8.3c-11.3,0-21.1,2.8-29.5,8.3c-8.4,5.5-14.9,13.6-19.6,24.4c-4.6,10.7-7,23.9-7,39.4 c0,15.6,2.3,28.7,7,39.4c4.6,10.7,11.2,18.8,19.6,24.4c8.4,5.5,18.2,8.3,29.5,8.3c11.3,0,21.1-2.8,29.5-8.3 c8.4-5.5,14.9-13.6,19.6-24.4C461.8,469.3,464.1,456.2,464.1,440.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M581.6,330.3v220.7h-46.7V330.3H581.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M793.7,330.3v220.7h-40.3l-96-138.9h-1.6v138.9h-46.7V330.3h40.9l95.3,138.8h1.9V330.3H793.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIcon);
export default __webpack_public_path__ + "static/media/coin_icon.7d4a8a1dd62eef85a7e9041cbab204da.svg";
export { ForwardRef as ReactComponent };